import { Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from '../features/auth/LoginPage';
import { AppLayout } from '../components/layout/AppLayout';
import { ProtectedRoute } from '../components/layout/ProtectedRoute';
import { AdminDashboardPage } from '../features/dashboard/AdminDashboardPage';
import { UserDashboardPage } from '../features/dashboard/UserDashboardPage';
import { ReportsPage } from '../features/reports/ReportsPage';
import { CouriersPage } from '../features/couriers/CouriersPage';
import { MerchantsListPage } from '../features/merchants/MerchantsListPage';
import { MerchantDetailPage } from '../features/merchants/MerchantDetailPage';
import { BranchesPage } from '../features/branches/BranchesPage';
import { SettingsPage } from '../features/settings/SettingsPage';
import { CredentialPacksPage } from '../features/credentials/CredentialPacksPage';
import { OrdersB2cPage } from '../features/orders/OrdersB2cPage';
import { OrdersBucketPage } from '../features/orders/OrdersBucketPage';
import { CustomersPage } from '../features/customers/CustomersPage';
import { OrdersB2bPage } from '../features/orders/OrdersB2bPage';
import { CreateOrderB2cPage } from '../features/orders/CreateOrderB2cPage';
import { CreateOrderB2bPage } from '../features/orders/CreateOrderB2bPage';
import { OrderDetailB2cPage, OrderDetailB2bPage } from '../features/orders/OrderDetailPage';
import { NdrPage } from '../features/ndr/NdrPage';
import { IvrPage } from '../features/ivr/IvrPage';
import { EddExpiredPage } from '../features/edd-expired/EddExpiredPage';
import { TicketsPage } from '../features/tickets/TicketsPage';
import { HelpPage } from '../features/help/HelpPage';
import { AdminWalletPage } from '../features/wallet/WalletPage';
import { WeightPage } from '../features/weight/WeightPage';
import { BulkPodPage } from '../features/pod/BulkPodPage';
import { CreditNotesB2cPage, CreditNotesB2bPage } from '../features/credit-notes/CreditNotesPage';
import { CreditNotesUnifiedPage } from '../features/credit-notes/CreditNotesUnifiedPage';
import { DebitNotesB2cPage, DebitNotesB2bPage } from '../features/debit-notes/DebitNotesPage';
import { DebitNotesUnifiedPage } from '../features/debit-notes/DebitNotesUnifiedPage';
import { InvoicesB2cPage, InvoicesB2bPage } from '../features/invoices/InvoicesPage';
import { InvoicesUnifiedPage } from '../features/invoices/InvoicesUnifiedPage';
import { LedgerPage } from '../features/ledger/LedgerPage';
import { LeadsRoutes } from '../features/leads/LeadsRoutes';
import { FreightB2cPage, FreightB2bPage } from '../features/freight/FreightPage';
import { FreightUnifiedPage } from '../features/freight/FreightUnifiedPage';
import { PriceCalculatorPage } from '../features/price-calculator/PriceCalculatorPage';
import { WmsRoutes } from '../features/wms/WmsRoutes';
import { RemittancePage } from '../features/remittance/RemittancePage';
import { MerchantApiPage } from '../features/merchant-api/MerchantApiPage';
import { ChannelsPage } from '../features/channels/ChannelsPage';
import { CourierMappingsPage } from '../features/courier-mappings/CourierMappingsPage';
import { CourierWebhooksPage } from '../features/courier-webhooks/CourierWebhooksPage';
import { InhouseOfdOrdersPage } from '../features/orders/InhouseOfdOrdersPage';
import { MasterDataPage } from '../features/master-data/MasterDataPage';
import { WalletLedgerPage } from '../features/wallet/WalletLedgerPage';
import { CourierApiLogsPage } from '../features/courier-api-logs/CourierApiLogsPage';
import { CronHistoryPage } from '../features/settings/CronHistoryPage';
import { NotificationsPage } from '../features/notifications/NotificationsPage';
import { PickupRequestsPage } from '../features/pickup-requests/PickupRequestsPage';
import { CourierPricingPage } from '../features/courier-pricing/CourierPricingPage';
import { UsersPage } from '../features/users/UsersPage';
import { HrPage } from '../features/hr/HrPage';
import { MyRequirementsPage } from '../features/hr/MyRequirementsPage';
import { LeaveRequestsPage } from '../features/hr/LeaveRequestsPage';
import TestOrdersPage from '../features/admin/TestOrdersPage';
import { RolesPage } from '../features/users/RolesPage';
import { TrackingB2cPage, TrackingB2bPage, TrackingHubPage } from '../features/orders/TrackingPage';
import { ServiceabilityPage } from '../features/serviceability/ServiceabilityPage';
import { AppointmentsPage } from '../features/appointments/AppointmentsPage';
import { MastersPage } from '../features/masters/MastersPage';
import { WarehousesPage } from '../features/warehouses/WarehousesPage';

function ProtectedShell() {
  return (
    <ProtectedRoute>
      <AppLayout portal="admin" />
    </ProtectedRoute>
  );
}

export function AdminApp() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage portal="admin" />} />
      <Route path="/" element={<ProtectedShell />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<AdminDashboardPage />} />
        <Route path="user-dashboard" element={<UserDashboardPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="couriers" element={<CouriersPage />} />
        <Route path="merchants" element={<MerchantsListPage />} />
        <Route path="merchants/:id" element={<MerchantDetailPage />} />
        <Route path="orders" element={<Navigate to="/orders-b2c" replace />} />
        <Route path="inhouse-ofd" element={<InhouseOfdOrdersPage />} />
        <Route path="master-data" element={<MasterDataPage />} />
        <Route path="wallet-ledger" element={<WalletLedgerPage />} />
        <Route path="orders-b2c" element={<OrdersB2cPage />} />
        <Route path="orders-bucket" element={<OrdersBucketPage />} />
        <Route path="customers" element={<CustomersPage />} />
        <Route path="merchants/:merchantId/customers" element={<CustomersPage />} />
        <Route path="orders-b2c/new" element={<CreateOrderB2cPage />} />
        <Route path="orders-b2c/:id" element={<OrderDetailB2cPage />} />
        <Route path="orders-b2b" element={<OrdersB2bPage />} />
        <Route path="orders-b2b/new" element={<CreateOrderB2bPage />} />
        <Route path="orders-b2b/:id" element={<OrderDetailB2bPage />} />
        <Route path="appointments" element={<AppointmentsPage />} />
        <Route path="tracking-b2c" element={<TrackingB2cPage />} />
        <Route path="tracking-b2b" element={<TrackingB2bPage />} />
        <Route path="tracking" element={<TrackingHubPage />} />
        <Route path="serviceability" element={<ServiceabilityPage />} />
        <Route path="masters" element={<MastersPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="roles" element={<RolesPage />} />
        <Route path="branches" element={<BranchesPage />} />
        <Route path="courier-mappings"   element={<CourierMappingsPage />} />
        <Route path="courier-webhooks"   element={<CourierWebhooksPage />} />
        <Route path="courier-api-logs"   element={<CourierApiLogsPage />} />
        <Route path="cron-history"       element={<CronHistoryPage />} />
        <Route path="pickup-requests"    element={<PickupRequestsPage />} />
        <Route path="courier-pricing"    element={<CourierPricingPage />} />
        <Route path="credentials" element={<CredentialPacksPage />} />
        <Route path="warehouses" element={<WarehousesPage />} />
        <Route path="ndr" element={<NdrPage />} />
        <Route path="ivr" element={<IvrPage />} />
        <Route path="edd-expired" element={<EddExpiredPage />} />
        <Route path="tickets" element={<TicketsPage />} />
        <Route path="help" element={<HelpPage />} />
        <Route path="wallet" element={<AdminWalletPage />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="weight" element={<WeightPage />} />
        <Route path="pod" element={<BulkPodPage />} />
        <Route path="credit-notes-b2c" element={<CreditNotesB2cPage />} />
        <Route path="credit-notes-b2b" element={<CreditNotesB2bPage />} />
        <Route path="credit-notes" element={<CreditNotesUnifiedPage />} />
        <Route path="debit-notes-b2c" element={<DebitNotesB2cPage />} />
        <Route path="debit-notes-b2b" element={<DebitNotesB2bPage />} />
        <Route path="debit-notes" element={<DebitNotesUnifiedPage />} />
        <Route path="invoices-b2c" element={<InvoicesB2cPage />} />
        <Route path="invoices-b2b" element={<InvoicesB2bPage />} />
        <Route path="invoices" element={<InvoicesUnifiedPage />} />
        <Route path="ledger" element={<LedgerPage />} />
        {/* Lead Management — its own sub-router, one route per sub-menu entry. */}
        <Route path="leads/*" element={<LeadsRoutes />} />
        <Route path="freight-b2c" element={<FreightB2cPage />} />
        <Route path="freight-b2b" element={<FreightB2bPage />} />
        <Route path="freight" element={<FreightUnifiedPage />} />
        <Route path="price-calculator" element={<PriceCalculatorPage />} />
        <Route path="wms/*" element={<WmsRoutes />} />
        <Route path="remittance" element={<RemittancePage />} />
        <Route path="api-keys" element={<MerchantApiPage />} />
        <Route path="channels" element={<ChannelsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="hr" element={<HrPage />} />
        <Route path="my-requirements" element={<MyRequirementsPage />} />
        <Route path="leave" element={<LeaveRequestsPage />} />
        <Route path="test-orders" element={<TestOrdersPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
